module.exports = __webpack_public_path__ + "img/8-text.d99a621c.png";